import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import moment from "moment";
import "moment-timezone";

import { AccountService } from "../../service/AccountService";
import { LanguageService } from "../../service/LanguageService";
import { getTimeZoneDisplay } from "../../utils/TimeUtil";
import { AppContext } from "../../HomePage";
import Currency from "./Currency";

const Preferences = ({ account, setAccount, onSaved }) => {
    const { t, toast, setError } = React.useContext(AppContext);
    const [languages] = useState(LanguageService.getLanguages());
    const [timezones] = useState(moment.tz.names());
    const [tzSuggestions, setTzSuggestions] = useState(null);
    const [disabled, setDisabled] = useState(false);
    const accountService = new AccountService();

    const suggestTimezones = (e) => {
        const q = e.query.toString().toLowerCase();
        setTzSuggestions(timezones.filter(tz => getTimeZoneDisplay(tz).toLowerCase().includes(q)));
    };
    const onChange = (e) => setAccount({ ...account, [e.target.name]: e.target.value });
    const changeLanguage = (e) => { onChange(e); LanguageService.setLanguage(e.target.value); };

    const save = () => {
        if (disabled) return;
        setDisabled(true);
        accountService.updateMyAccount(account).then(updated => {
            onSaved(updated);
            toast.current.show({ severity: 'success', summary: t('account.save_account', 'Account saved'), detail: t('message_detail.successful', 'Successful') });
            setDisabled(false);
        }).catch(error => { setError(error); setError(null); setDisabled(false); });
    };

    return (
        <div className="acc-prefs-grid">
            <div className="acc-section">
                <p className="acc-section-title">{t('account.prefs.region_title', 'Region & language')}</p>
                <p className="acc-section-sub">{t('account.prefs.region_sub', 'Set your display language and time zone.')}</p>
                <div className="p-fluid">
                    <div className="acc-field">
                        <label htmlFor="language">{t('user.language', 'Language')}</label>
                        <Dropdown id="language" name="language" value={account.language} options={languages}
                                  onChange={changeLanguage} itemTemplate={(e) => e.label} />
                    </div>
                    <div className="acc-field">
                        <label htmlFor="timezone">{t('user.timezone', 'Time zone')}</label>
                        <AutoComplete id="timezone" name="timezone" field="label" dropdown value={account.timezone}
                                      suggestions={tzSuggestions} completeMethod={suggestTimezones}
                                      itemTemplate={(e) => getTimeZoneDisplay(e)} onChange={onChange} />
                    </div>
                    <Button label={t('actions.save', 'Save')} icon="pi pi-save" className="p-button-outlined p-button-success" onClick={save} disabled={disabled} />
                </div>
            </div>
            <div className="acc-section">
                <p className="acc-section-title">{t('account.prefs.currency_title', 'Currency rates')}</p>
                <p className="acc-section-sub">{t('account.prefs.currency_sub', 'Conversion rates applied to your account (read-only).')}</p>
                <Currency />
            </div>
        </div>
    );
};
export default Preferences;
